/** A single Google action can provision access and refresh claims transparently. */
export async function exchangePortalSession(
  getIdToken: () => Promise<string>,
  appCheckToken: string | null | undefined,
  invitationId?: string,
  fetcher: typeof fetch = fetch
): Promise<void> {
  for (let attempt = 0; attempt < 2; attempt++) {
    const response = await fetcher("/api/session", {
      method: "POST", credentials: "include",
      headers: { "Content-Type": "application/json", ...(appCheckToken ? { "X-Firebase-AppCheck": appCheckToken } : {}) },
      body: JSON.stringify({ idToken: await getIdToken(), ...(invitationId ? { invitationId } : {}) })
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.error ?? "This account does not have portal access");
    if (body.authenticated === true) return;
    if (body.refreshRequired !== true) throw new Error("The secure portal session was not accepted. Try signing in again.");
  }
  throw new Error("Your new access could not be refreshed. Try signing in again with the invited account.");
}
